import { useEffect } from "react";
import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';

import introJs from 'intro.js';
import 'intro.js/introjs.css'
import '../../ccIntroJs/ccIntroJsStyles.css'
import { CcIntroJsStyledText } from '../../ccIntroJs/ccIntroJsStyledText';
import { showIntroJsTourForCurrentPage } from '../../ccIntroJs/ccIntroJsDisplayLogic';

export default function ProductHomeMoodMeter() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;

        showIntroJsTourForCurrentPage(introJs)
    }, [])

    return <div>
            <CcTitle>
                Mood Meter
            </CcTitle>
            <div className="text-ccColorDarkTeal">Monitor recipient email satisfaction with this auto-updating rating feature.</div>
            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Start here', mainText: 'This launches a wizard that: <ul class="list-disc ml-4">  <li>Creates a <span class="font-semibold">template</span></li><li>Creates an <span class="font-semibold">element</span></li></ul><div class="mt-2">A <span class="font-semibold">template</span> is a reusable design. You can create multiple elements from the same template</div><div class="mt-2">An <span class="font-semibold">element</span> is the html tag to copy into your email</div>'})}>
                <Link to={`/workflow/7`} style={linkStyle}> 
                    <CcCreateNewSnippet className="mt-4" >Create new Mood Meter</CcCreateNewSnippet>
                </Link>
            </div>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Template section', mainText: '<div>Here you can view/edit your templates</div><div>You can also create a new element from an existing template</div>'})}>
                    <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                </div>
                <div>
                <TemplateGallery productTypeId={7} />
                </div>
            </div>

            <div className="w-fit" data-intro={CcIntroJsStyledText({title: 'Elements section', mainText: '<div>List of all the Elements you created</div><div>You can edit an element even if you have already put it in a live email</div>'})}>
                <CcSubSectionTitle className=" mt-6">Latest Mood Meter Elements</CcSubSectionTitle>
            </div>
            <SnippetsGrid productTypeId={7}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}